// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../../../common/JQueryView';
import SearchAddressForm from '../../../../../common/SearchAddressForm';

export default class NewView extends JQueryView {
  searchAddress: Object;

  constructor() {
    super('.change-owners-wrapper');
    this.searchAddress = new SearchAddressForm('.change-owners-wrapper');
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .hide();
    event.preventDefault();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
  }

  // 付与者区分
  @on({ event: 'change', selector: '.holder_type' })
  onChangeHolderType(el: any) {
    const target = $(el.currentTarget);

    // 法人エリアの出しわけ
    const companyArea = $('.company-area');
    if (target.attr('id') === 'holderTypeCompany') {
      companyArea.removeClass('d-none');
      $(
        'label[for="company_stock_option_change_owner_form_to_rightholder_attributes_last_name"]',
      ).html('姓（担当者）');
      $(
        'label[for="company_stock_option_change_owner_form_to_rightholder_attributes_first_name"]',
      ).html('名（担当者）');
    } else {
      $(
        '#company_stock_option_rightholder_form_stakeholder_attributes_company_name',
      ).val('');
      $(
        '#company_stock_option_rightholder_form_stakeholder_attributes_representative_last_name',
      ).val('');
      $(
        '#company_stock_option_rightholder_form_stakeholder_attributes_representative_first_name',
      ).val('');
      companyArea.addClass('d-none');
      $(
        'label[for="company_stock_option_change_owner_form_to_rightholder_attributes_last_name"]',
      ).html('姓（漢字）');
      $(
        'label[for="company_stock_option_change_owner_form_to_rightholder_attributes_first_name"]',
      ).html('名（漢字）');
    }
  }

  // 登記上の住所
  @on({ event: 'change', selector: '.overseas' })
  onChangeOverseas(el: any) {
    const target = $(el.currentTarget);

    // 国内エリアの出しわけ
    const domesticAreas = $('.domestic');

    if (target.attr('id') === 'overseasFalse') {
      domesticAreas.each(function(_i, el) {
        $(el).removeClass('d-none');
      });
    } else {
      domesticAreas.each(function(_i, el) {
        $(el).addClass('d-none');
        $(
          '#company_stock_option_rightholder_form_stakeholder_attributes_prefecture',
        ).val('');
        $(
          '#company_stock_option_rightholder_form_stakeholder_attributes_city',
        ).val('');
        $(
          '#company_stock_option_rightholder_form_stakeholder_attributes_address_detail',
        ).val('');
      });
    }
  }
}
